import React, { useEffect } from "react";
import { Outlet } from "react-router-dom";
import { PageHeader } from "../components/PageHeader";
import { BudgetProvider } from "../BudgetContext";
import classes from "./BudgetDemoShell.module.less";

/** The big re-layout when the budget moves between review stages makes antd's
 * resize-observed widgets emit the benign "ResizeObserver loop completed with
 * undelivered notifications" warning. It's harmless (the browser settles on the
 * next frame), so swallow it before the dev error overlay surfaces it. The
 * capture-phase listener runs before the overlay's. */
const useSuppressResizeObserverError = () =>
    useEffect(() => {
        const handler = (e: ErrorEvent) => {
            if (e.message?.startsWith("ResizeObserver loop")) {
                e.stopImmediatePropagation();
            }
        };
        window.addEventListener("error", handler, true);
        return () => window.removeEventListener("error", handler, true);
    }, []);

const ShellInner: React.FC = () => {
    useSuppressResizeObserverError();
    return (
        <div className={classes.wrap}>
            <PageHeader
                title="Financial Planning"
                subtitle="Build a defensible annual budget from your contracts and spend — forecast next year line by line, then track the year's plan against actuals."
            />
            <Outlet />
        </div>
    );
};

/** Embedded budget demo: owns the workspace state (BudgetProvider) and the
 * fixed "Budget" title. Each view renders its own metrics banner, then the
 * segment tabs, then its content. Renders inside AppLayout's content area. */
export const BudgetDemoShell: React.FC = () => (
    <BudgetProvider>
        <ShellInner />
    </BudgetProvider>
);
